import {accountMovement} from "./en/accountMovement";
import {balanceBonus} from "./en/balanceBonus";
import {bankDeposit} from "./en/bankDeposit";
import {baseModalTitles} from "./en/baseModalTitles";
import {breadcrumbs} from "./en/breadcrumbs";
import {changePassword} from "./en/changePassword";
// import accounts from "./en/accounts";
import {contact} from "./en/contact";
import {cookieConsent} from "./en/cookieConsent";
import {currency} from "./en/currency";
import {deleteAccount} from "./en/deleteAccount";
import {dropdownMenu} from "./en/dropdownMenu";
import {errorBoundary} from "./en/errorBoundary";
import {floatBtn} from "./en/floatBtn";
import {floatingMenu} from "./en/floatingMenu";
import {footer} from "./en/footer";
import {gameFeed} from "./en/gameFeed";
import {games} from "./en/games";
import {homeBtnMoneyHandler} from "./en/homeBtnMoneyHandler";
import {homeModalSessionInfo} from "./en/homeModalSessionInfo";
import {identity} from "./en/identity";
import {inviteFriend} from "./en/inviteFriend";
import {loginModal} from "./en/loginModal";
import {lottery} from "./en/lottery";
import {mobilePayment} from "./en/mobilePayment";
import {news} from "./en/news";
import {notificationDrawer} from "./en/notificationDrawer";
import {notifications} from "./en/notifications";
import {promoBanners} from "./en/promoBanners";
import {quiniela} from "./en/quiniela";
import {raffle} from "./en/raffle";
import {registrationForm} from "./en/registrationForm";
import {sideNavbar} from "./en/sideNavbar";
import {socialNotifications} from "./en/socialNotifications";
import {socialSelector} from "./en/socialSelector";
import {contactSupport} from "./en/support";
import {TOS} from "./en/TOS";
import {testimonials} from "./en/testimonials";
import {transactionTitles} from "./en/transactionTitles";
import {transferSteps} from "./en/transferSteps";
import {userProfile} from "./en/userProfile";
import {wallet} from "./en/wallet";
import {withdrawalSteps} from "./en/widthdrawalSteps";

const en = {
  // ...accounts,
  ...contact,
  ...cookieConsent,
  ...contactSupport,
  ...bankDeposit,
  ...currency,
  ...sideNavbar,
  ...dropdownMenu,
  ...registrationForm,
  ...identity,
  ...userProfile,
  ...floatBtn,
  ...withdrawalSteps,
  ...homeBtnMoneyHandler,
  ...transferSteps,
  ...wallet,
  ...inviteFriend,
  ...changePassword,
  ...mobilePayment,
  ...accountMovement,
  ...transactionTitles,
  ...baseModalTitles,
  ...footer,
  ...notificationDrawer,
  ...notifications,
  ...deleteAccount,
  ...TOS,
  ...lottery,
  ...raffle,
  ...balanceBonus,
  ...loginModal,
  ...errorBoundary,
  ...games,
  ...gameFeed,
  ...breadcrumbs,
  ...floatingMenu,
  ...homeModalSessionInfo,
  ...socialSelector,
  ...promoBanners,
  ...socialNotifications,
  ...testimonials,
  ...news,
  noDataAvailable: "No data available",
  loading: "Loading...",
  homeDisplaySportsTitle: "Sports Betting",
  homeDisplaySportsSubtitle: "Play in the best leagues in the world",
  homeDisplayContestChallengeTitle: "CONTEST - Challenge from beyond",
  latestWinners: "Latest Winners",
  homeDisplayTopGamesTitle: "10 Most Played!",
  homeDisplayAllBtn: "View All",
  homeDisplayLoginBtn: "Login",
  homeDisplayRegisterBtn: "Register",
  homeDisplayLiveGames: "Upcoming Games",
  homeDisplayLiveGamesSubtitle: "Bet with the best odds",
  homeDisplayFootball: "Football",
  homeDisplayTennis: "Tennis",
  homeDisplayBasketball: "Basketball",
  homeDisplayVolleyball: "Volleyball",
  homeDisplayEventRules: "Event Rules",
  homeDisplayModalTitle: "Promotion",
  homeDisplayModalClose: "Close",
  homeModalSessionInfoAtTime: "at",
  referralMessage: "Join Randrush and enjoy exclusive benefits! Sign up using my referral link ",
  referralMessageSlots: "Sign up here and receive 10 free spins on slots! ",
  referralMessageSports: "Create your account and get an exclusive bonus to bet on your favorite sport! ",
  referralMessageBingo: "Create your account and receive free bingo cards! ",
  referralMessageCasino: "Create your account and receive free chips for the live casino! ",
  selectMessageType: "Select message type",
  messageTypeGeneral: "General",
  messageTypeSlots: "Slots",
  messageTypeSports: "Sports",
  messageTypeBingo: "Bingo",
  messageTypeCasino: "Casino",
  messagePreview: "Message Preview",
  copy: "Copy",
  share: "Share",
  scanQR: "Scan QR",
  scanQRText: "Scan this QR to referral friend",
  copyQR: "Copy QR",
  downloadQR: "Download QR",
  shareQR: "Share QR",
  qrCopied: "QR code copied to clipboard!",
  qrCopyFailed: "Failed to copy QR code. Please try downloading instead.",
  recentReferrals: "Recent Referrals",
  referralProgram: "Referral Program",
  youReferralStatus: "Your referral status",
  sharedYourLink: "You can share your referral link by copying and sending it or sharing it on your social media",
  referralEarnings: "Referral Earnings",
  referralSummary: "Referral Summary",
  yourReferrals: "Your Referrals",
  yourReferralsEarned: "Your Referrals Earned",
  yourReferralsPendingEarned: "Your Referrals Pending Earned",
  yourReferralLink: "Your link",
  qrCode: "QR Code",
  joinedDate: "Joined Date",
  date: "Date",
  depositDate: "Deposit Date",
  status: "Status",
  reward: "Reward",
  active: "Active",
  inactive: "Inactive",
  noReferralsFound: "No recent referrals found.",
  totalReferrals: "Total Referrals",
  activeReferrals: "Active Referrals",
  hasDeposited: "Has Deposited",
  yes: "Yes",
  no: "No",
  pending: "Pending",
  paid: "Paid",
  recentEarnings: "Recent Earnings",
  noCommissionsYet: "No commissions yet",
  commission: "commission",
  totalCommission: "Total Commission",
  forgotReferralCode: "Forgot to add referral code in your profile?",
  clickHere: "Click Here",
  referralCodePlaceholder: "Enter your referral code",
  send: "Send",
  sending: "Sending...",
  referralCodeAppliedSuccess: "Referral code applied successfully!",
  invalidOrInactiveReferralCode: "The referral code is invalid or inactive",
  cashbackTitle: "Cashback Total 13%",
  cashbackDesc: "Every Monday receive 13% of everything you played. All games!",
  cashbackActive: "Active",
  cashbackPayday: "Payday!",
  cashbackNextMonday: "Next Monday",
  cashbackBannerAria: "Cashback 13% promotion — Every Monday",
  registerPromoTag: "Registration promo",
  registerPromoTitle: "Register and win free spins",
  registerPromoDesc: "For every 40 VEs you deposit on your first deposit, we give you a free spin.",
  registerPromoCta: "Register",
  registerPromoAria: "Registration promotion — Free spins on your first deposit",
  mondaySpinsTag: "Every Monday",
  mondaySpinsTagToday: "It's Monday!",
  mondaySpinsTitle: "Free spins every Monday",
  mondaySpinsDesc: "For every R 40 you deposit on the first deposit of the day, we give you a free spin.",
  mondaySpinsNextMonday: "Next Monday",
  mondaySpinsDeposit: "Deposit",
  mondaySpinsAria: "Monday promotion — Free spins every Monday",
  dailySpinsTitle: "Spin and win double",
  dailySpinsDesc:
    "From Monday to Monday except Thursday, for every spin you make between 8 and 9 pm we give you a courtesy spin.",
  dailySpinsTag: "Every day except Thursdays",
  dailySpinsNextActive: "Next active in",
  homeHeroTagPromo: "Promo",
  homeHeroTagNew: "New Move",
  homeHeroTagDrop: "Drop",
  homeHeroTagRace: "Race",
  homeHeroTagTournament: "Tournament",
  miniGamesTitle: "Mini Games",
  miniGamesViewAll: "View all",
  miniGamesCarouselAria: "Casino mini games carousel",
  categoryUnavailableTag: "Coming soon",
  categoryUnavailableTitle: "We're improving this category",
  categoryUnavailableTitleNamed: "We're improving the {{category}} experience",
  categoryUnavailableMessage:
    "This section will be available again very soon. We're working on a better experience for you. Thanks for your patience.",
  categoryUnavailableBack: "Back to home",
  categoryUnavailableExplore: "Explore other games",
  ...quiniela,
};

export default en;
